export default function FeatureItem({ icon, title, description, tone }) {
  return (
    <article className="text-center">
      <div className={`mx-auto mb-5 flex h-16 w-16 items-center justify-center ${tone}`}>{icon}</div>
      <h3 className={`mx-auto max-w-[135px] text-base font-extrabold leading-5 ${tone}`}>{title}</h3>
      <p className="mx-auto mt-3 max-w-[145px] text-sm leading-6 text-slate-600">{description}</p>
    </article>
  )
}
